<template>
  <v-dialog
    class="modal-overlay"
    v-model="modalVisible"
    :max-width="maxWidth"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :persistent="persistent"
  >
    <v-card
      :class="{ 'rounded-0': $vuetify.breakpoint.xsOnly }"
      elevation="0"
      :data-testid="dataTestId"
    >
      <div class="modal-content" :class="contentClass">
        <div class="d-flex align-start">
          <slot name="header"></slot>
          <div class="close-button ml-auto" v-if="showCloseButton">
            <v-btn data-testid="close-modal-button" icon @click="modalVisible = false">
              <v-icon size="20">mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </div>
        <slot />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Modal",
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    maxWidth: {
      type: String,
      default: "600px",
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    dataTestId: {
      type: String,
      default: "",
    },
    contentClass: {
      type: String,
      default: "",
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
        if (!value) {
          this.onClose();
        } else {
          this.onOpen();
        }
      },
    },
  },
  methods: {
    handleClose() {
      this.onClose();
    },
    handleOpen() {
      this.onOpen();
    },
  },
};
</script>

<style scoped>
.modal-content {
  border-radius: 0.5rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
}

.close-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  > * {
    padding: 0 !important;
    margin: 0 !important;
    min-width: auto !important;
    width: auto !important;
    height: auto !important;
  }
}
</style>
